import { Component, Pipe, PipeTransform, OnDestroy, HostListener } from '@angular/core';
import {Title} from '@angular/platform-browser';

import {UserService} from '../shared/user.service';
import {UserSettingsService} from '../shared/user-settings.service';
import {ApiService} from '../shared/api.service';
import {ViewService} from '../shared/view.service';
import { PermissionsService } from '../shared/permissions.service';
import { Permissions } from '../shared/permissions.enum';

@Pipe({name: 'keyvalue', pure: false})
export class KeyValuePipe implements PipeTransform {
    transform(obj) {
        if( !obj  ) {
            return [];
        }
        return Object.values(obj);
    }
}
@Component({
    selector: 'menu-component',
    templateUrl: 'menu.component.html'
})
export class MenuComponent implements OnDestroy {
    options = [
        {
            title: 'My Queue',
            routerLink: ['/assignments', 'queue'],
            icon: 'assignment',
            limit: ['contributor', 'pageAddWriter', 'writer', 'editor', 'administrator'], // typescript issue with indexOf
            limited: false
        },
        {
            title: 'My Profile',
            routerLink: ['/users', 'profile', this.api.getProp('currentUserId')],
            icon: 'badge',
            limit: ['contributor', 'pageAddWriter', 'writer', 'editor', 'administrator'],
            limited: false
        },
        {
            title: 'Create',
            routerLink: ['/assignment/create'],
            icon: 'mode_edit',
            limit: ['editor', 'administrator'],
            limited: false,
            submenu: [
                {
                    routerLink: ['/assignment/create'],
                    title: 'Slideshow'
                },
                // {
                //     routerLink: ['/assignment/create/summary'],
                //     title: 'Summary'
                // },
                {
                    routerLink: ['/assignment/create/quiz'],
                    title: 'Quiz'
                },
                {
                    routerLink: ['/assignment/create/rsoc'],
                    title: 'RSOC'
                }
            ],

        },
        {
            title: 'Sent to Editor',
            routerLink: ['/assignments', 'sent-to-editor'],
            icon: 'send',
            limit: ['administrator', 'editor'],
            limited: false
        },
        {
            title: 'Syndication Sent to Editor',
            routerLink: ['/assignments', 'syn-sent-to-editor'],
            icon: 'send',
            limit: ['administrator', 'editor'],
            limited: false
        },
        {
            title: 'Ready to Delete Apple News',
            routerLink: ['/assignments', 'ready-to-delete-an'],
            icon: 'send',
            limit: ['administrator', 'editor'],
            limited: false
        },
        {
            title: 'Ready to Repost',
            routerLink: ['/assignments', 'ready-to-repost'],
            icon: 'send',
            limit: ['administrator', 'editor'],
            limited: false
        },
        {
            title: 'Assigned',
            routerLink: ['/assignments', 'assigned'],
            icon: 'assignment_ind',
            limit: ['administrator', 'editor'],
            limited: false
        },
        {
            title: 'All Articles',
            routerLink: ['/assignments'],
            icon: 'view_list',
            limit: ['editor', 'dmc', 'administrator'],
            limited: false
        },
        {
            title: 'Import',
            routerLink: ['/import'],
            icon: 'get_app',
            limit: ['editor', 'administrator'],
            limited: true
        },
        {
            title: 'Users',
            routerLink: ['/users'],
            icon: 'person',
            limit: ['administrator', 'editor'],
            limited: false
        },
        {
            title: 'Tools',
            routerLink: ['/tools'],
            icon: 'construction',
            limit: ['editor', 'administrator'],
            limited: false,
            submenu: [
                {
                    title: 'Bulk Clone',
                    routerLink: ['/tools/bulk-clone'],
                    limit: ['editor', 'administrator'],
                    limited: false
                }
            ]
        }
    ];
    user;
    userMenuOpen = false;
    updateAvailable = false;
    heartbeatSubscription;
    messageOpen = false;

    @HostListener('document:click', ['$event'])
    closeUserMenu(e) {
        if( !e.target.classList.contains('user-menu-toggle') && this.userMenuOpen ) {
            this.userMenuOpen = false;
        }
    }

    get Permissions() {
        return Permissions;
    }

    constructor(public vs: ViewService, private titleService: Title, public userService: UserService, public userSettings: UserSettingsService, private api: ApiService, public permissionsService: PermissionsService) {
        const user = api.getProp('user');
        const limited = user.limited.length > 0;
        this.user = user;
        this.options = this.options.filter(option => {
            if( limited && option.limited ) {
                return false;
            }
            return option.limit.indexOf('any') !== -1 || option.limit.indexOf(user.role) !== -1;
        });
        this.heartbeatSubscription = this.api.versionChange.subscribe(() => {
            this.updateAvailable = true;
            this.messageOpen = true;
        });
    }
    ngAfterViewInit() {
        if( this.api.getProp('_versionChanged') ) {
            this.updateAvailable = true;
            this.messageOpen = true;
        }
    }
    logout() {
        this.api.removeNonce();
        this.api.doAction('post', 'login', {
            logout: true
        }).subscribe(
            data => {
                this.userService.setCurrentUser(0);
            }
        );
    }
    setTitle(title) {
        this.titleService.setTitle('SWARM | ' + title);
    }
    toggleUserMenu() {
        this.userMenuOpen = !this.userMenuOpen;
    }
    update() {
        window.location.reload(true);
    }
    toggleMessage() {
        this.messageOpen = !this.messageOpen;
    }
    setSubmenuPosition(e, option) {
        if( !option.submenu ) {
            return;
        }
        const li = e.target.parentElement;
        const ul = li.parentElement;
        const submenu = li.querySelector('.submenu');
        if( !submenu ) {
            return;
        }
        submenu.setAttribute('style', 'top: ' + (li.offsetTop - ul.scrollTop) + 'px');
    }
    ngOnDestroy() {
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
}